import React, { useMemo } from 'react';
import { DEFAULT_COMPANY_VARIABLES } from './flags';
import { CompanyContext } from '../providers/companyProvider'; 

export function useFeatureFlag( { name } ) {
    return useFeatureFlags( [ name ] )?.[ 0 ];
}

export function useFeatureFlags( names ) {
    const { company } = React.useContext( CompanyContext );

    return useMemo( () => {
        if ( !names ) {return [];}

        const processFlag = ( name ) => {
            const flag = company?.variableList?.find( v => v.name == name );

            // Before the company has loaded (or when a variable isn't set) fall back
            // to the documented default. This keeps the result a stable, correctly
            // sized array instead of an empty one, so flag values don't depend on
            // render timing (which previously hid flag-gated items mid-load).
            if ( flag === undefined ) {
                return DEFAULT_COMPANY_VARIABLES[ name ] ?? false;
            }

            if ( flag.value ) {
                return flag.value == 'true';
            } else {
                return flag.value;
            }
        };

        return names.map( processFlag );
    // `names` is folded into the dependency via join so a fresh array literal with
    // the same contents doesn't recompute, while changes to either are picked up.
    }, [ company, names?.join( ',' ) ] );
}

export function FeatureFlag( { name, children, fallback = null } ) {
    const isAllowed = useFeatureFlag( { name } );

    return isAllowed ? children : fallback;
}
